import { useQuery } from "@apollo/client";
import { GET_FESTIVAL_SETTINGS, UPDATE_FESTIVAL_SETTINGS } from "./graphql";
import { ISettingsProps, SettingsForm } from "./form";
import { LoadingOverlay } from "../../components/Loading";
import { Setting } from "../../__generated__/graphql";
import { PageContainer } from "../../components/PageContainer";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import { ManageConfig } from "../config";
import { useIsSuperAdmin } from "../../App";
import { SuperAdminTab } from "./superadmin";

export const Settings = () => {
  const isSuperAdmin = useIsSuperAdmin();
  const [value, setValue] = React.useState(0);
  const tabs = React.useMemo(() => {
    const base = [
      { label: "Config", content: <ManageConfig /> },
      { label: "App Settings", content: <SettingsTab /> },
    ];
    if (isSuperAdmin) {
      base.push({ label: "Super Admin", content: <SuperAdminTab /> });
    }
    return base;
  }, [isSuperAdmin]);

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
    setValue(newValue);
  };

  return (
    <PageContainer title={`Settings`}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="settings tabs"
      >
        {tabs.map((tab, index) => (
          <Tab key={tab.label} label={tab.label} value={index} />
        ))}
      </Tabs>
      {tabs.map((tab, index) => (
        <CustomTabPanel key={tab.label} value={value} index={index}>
          {tab.content}
        </CustomTabPanel>
      ))}
    </PageContainer>
  );
};
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
export const SettingsTab = () => {
  const { data, error, loading } = useQuery(GET_FESTIVAL_SETTINGS);

  if (loading) return <LoadingOverlay loading={loading} />;

  // if (!data?.settings[0]) return null;

  const defaults: ISettingsProps = {
    editionId: "",
    // @ts-expect-error
    setting: {
      downForMaintenance: false,
      editionId: "",
      minVersion: "0.0.1",
      id: 1,
      countdownDate: null,
    },
  };

  return (
    <SettingsForm
      // @ts-ignore
      setting={data?.settings[0] ?? defaults.setting}
      versionNumber={data?.versionNumber ?? defaults.versionNumber}
    />
  );
};
